import { __assign } from "tslib";
import React from 'react';
import IconWrap from '../IconWrap';
var FolderSync = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 24 24" },
        React.createElement("g", null,
            React.createElement("path", { d: "M15 4.44L13.68 4h-3.36L9 4.44V6H7V3l3-1h4l3 1v3h4l1 1.06V21l-1 1H3l-1-1V7l1-1h12V4.44zM19 14h-5l1.86 1.81-1 1.19A4.14 4.14 0 0112 18.15 4.14 4.14 0 019.14 17H6.81a6 6 0 0010.3.11L19 19v-5zm-6.38-5.94a6 6 0 00-5.73 2.83L5 9v5h5l-1.76-1.76A4.59 4.59 0 0112 9.85 4.14 4.14 0 0115.65 12h2a6 6 0 00-5.03-3.94z" }))))); };
FolderSync.displayName = 'FolderSync';
export default FolderSync;
//# sourceMappingURL=FolderSync.js.map